// extracted by mini-css-extract-plugin
module.exports = {"glossaryContent":"ContentBookContainer_glossaryContent__1Z2cV","glossaryScrollBox":"ContentBookContainer_glossaryScrollBox__Lrx_T"};